import { Controller } from "remult";

@Controller("volunteer-org-project-methods")
export class VolunteerOrgProjectMethods {}
